<template>
    
        <!-- 
            <div class="col-lg-5 col-md-7 mb-2">
            <div class="card bg-secondary shadow border-0">
                <div class="card-body px-lg-5 py-lg-5">
                    <div class="text-center text-muted mb-4">
                        <small>Saisissez vos données</small>
                    </div>

                    <form role="form"
                        <base-input class="input-group-alternative mb-3"
                                    :placeholder="$i18n.t('message.fileNumber')"
                                    addon-left-icon="ni ni-book-bookmark"
                                    :valid="$v.form.numero_dossier.$dirty ? !$v.form.numero_dossier.$error || !$v.form.numero_dossier.integer || !$v.form.numero_dossier.minLength : null"
                                    :error="numeroDossierError"
                                    v-model="$v.form.numero_dossier.$model"
                                    @click="clearErrorField('numero_dossier')"
                        >
                        </base-input>

                        <div class="error" style="color: red" v-if="errorshasField('numero_dossier')">{{getErrorsField('numero_dossier')}}</div>
                        
                        <base-input class="input-group-alternative mb-3"
                                    type="date"
                                    :placeholder="$i18n.t('message.dob')"
                                    addon-left-icon="fas fa-calendar-alt"
                                    :valid="$v.form.date_de_naissance.$dirty ? !$v.form.date_de_naissance.$error : null"
                                    :error="($v.form.date_de_naissance.$dirty && $v.form.date_de_naissance.$error) ? (!$v.form.date_de_naissance.required ? $t('message.requiredField') : $t('message.date_de_naissanceNotValid')) : null"
                                    v-model="$v.form.date_de_naissance.$model"
                                    @click="clearErrorField('date_de_naissance')"
                        >
                        </base-input>

                        <div class="error" style="color: red" v-if="errorshasField('date_de_naissance')">{{getErrorsField('date_de_naissance')}}</div>
                        
                        <base-input class="input-group-alternative mb-3"
                                    :placeholder="$i18n.t('message.phoneNumber')"
                                    addon-left-icon="fas fa-phone-volume"
                                    :valid="$v.form.telephone.$dirty ? !$v.form.telephone.$error || !$v.form.telephone.integer || !$v.form.telephone.minLength : null"
                                    :error="telephoneError"
                                    v-model="$v.form.telephone.$model"
                                    @click="clearErrorField('telephone')"
                        >
                        </base-input>

                        <div class="error" style="color: red" v-if="errorshasField('telephone')">{{getErrorsField('telephone')}}</div>
                       
                        <b-form-group
                                id="question-group"
                                label-for="question">
                            <select id="question"  v-model="$v.form.question_id.$model" required
                                    class="form-control is-invalid retirerBordure"
                            >
                                <option v-for="item in mQuestions" :value="item.value" :key="item.value">
                                    {{ item.text }}
                                </option>
                            </select>

                        </b-form-group>
                        <base-input class="input-group-alternative mb-3"
                                    :placeholder="$i18n.t('message.answer')"
                                    addon-left-icon="fas fa-reply"
                                    :valid="$v.form.reponse.$dirty ? !$v.form.reponse.$error : null"
                                    :error="($v.form.reponse.$dirty && $v.form.reponse.$error) ? (!$v.form.reponse.required ? $t('message.requiredField') : $t('message.reponseNotValid')) : null"
                                    v-model="$v.form.reponse.$model"
                                    @click="clearErrorField('question_id')"
                        >
                        </base-input>
                        <div class="error" style="color: red" v-if="errorshasField('question_id')">{{getErrorsField('question_id')}}</div>


                        <div class="text-center">
                            <base-button type="primary" class="my-4" @click="reset">{{$t('message.submit')}}</base-button>
                        </div>
                    </form>
                </div>
            </div>
        </div> -->

        <div class="col-lg-12 col-md-12 mt-5 m-0">
            <div class="card bg-secondary shadow border-0 m-0">
                <div class="card-body m-0">
                    <div class="text-center text-muted mb-4">
                        <small>Saisissez votre adresse mail</small>
                    </div>

                    <form role="form">

                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Email"
                                    addon-left-icon="ni ni-email-83"
                                    :valid="$v.model.email.$dirty ? !$v.model.email.$error : null"
                                    :error="($v.model.email.$dirty && $v.model.email.$error) ? (!$v.model.email.required ? $t('message.requiredField') : $t('message.emailNotValid')) : null"
                                    v-model="$v.model.email.$model"
                                    @click="clearErrorField('email')"
                        >
                        </base-input>
                        <div class="error" style="color: red" v-if="errorshasField('email')">{{getErrorsField('email')}}</div>

                        <div class="d-flex justify-content-center" v-if="isLoadEmail">
                            <div class="loading"></div>
                        </div>
                        <div class="text-center" v-else>
                            <base-button type="primary" class="my-4" @click="submit">{{$t('message.submit')}}</base-button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    
</template>

<script>
    import AppConfig from "../../constants/AppConfig";
    import {required,email,integer,minLength} from "vuelidate/lib/validators";
    import { mapGetters } from 'vuex';
    import _ from "lodash";
    import SlimSelect from "slim-select";


    export default {
        name: "Email",
        computed: {
            ...mapGetters(["errors","questions",]),

            mQuestions: function() {
                let qArray = [];

                _.forOwn(this.questions, function(value, key) {
                    qArray.push({ text: value.intitule, value: value.id });
                });

                return qArray;
            },

            telephoneError:function () {
                if (this.$v.form.telephone.$dirty && (this.$v.form.telephone.$error || !this.$v.form.telephone.integer || !this.$v.form.telephone.minLength)) {
                    if (!this.$v.form.telephone.required){
                        return this.$t('message.requiredField');
                    }else if (!this.$v.form.telephone.integer){
                        return this.$t('message.integer', { n: 9 });
                    }else if(!this.$v.form.telephone.minLength){
                        return this.$t('message.minCharacters', { n: 9 }) ;
                    }
                    return null;
                }
                return null;
            },

            numeroDossierError:function () {
                if (this.$v.form.numero_dossier.$dirty && (this.$v.form.numero_dossier.$error || !this.$v.form.numero_dossier.integer || !this.$v.form.numero_dossier.minLength)) {
                    if (!this.$v.form.numero_dossier.required){
                        return this.$t('message.requiredField');
                    }else if (!this.$v.form.numero_dossier.integer){
                        return this.$t('message.integer', { n: 8 });
                    }else if(!this.$v.form.numero_dossier.minLength){
                        return this.$t('message.minCharacters', { n: 8 }) ;
                    }else if (this.errorshasField('numero_dossier')){
                        return this.getErrorsField('numero_dossier');
                    }
                    return null;
                }
                return null;
            },

        },
        data() {
            return {
                model: {
                    email: '',
                },
                form:{
                    numero_dossier:'',
                    date_de_naissance:'',
                    telephone:'',
                    question_id:null,
                    reponse:''
                },
                errorMessage:'',
                isLoadEmail: false
            }
        },

        methods: {
            getQuestionsList() {
                let args = {
                };

                this.$store.dispatch('getQuestions', { args : args });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            },

            invalidEmail: function() {
                if (this.$v.model.email.$dirty && this.$v.model.email.$error) {
                    return !this.$v.model.email.required ?
                        this.$i18n.t('message.requiredField') :
                        this.$i18n.t('message.emailNotValid');
                }

                return null;
            },

            submit: function() {
                this.$v.model.$touch();

                if(!this.$v.model.$invalid) {
                    let args = {
                        email: this.model.email
                    };
                    this.isLoadEmail = true;
                    this.$store.dispatch('emailHandler', { args }).then(() => {
                        setTimeout(() => {
                            this.isLoadEmail = false;
                        }, 5000)
                    }).catch(error => {
                        this.isLoadEmail = false;
                    });
                }
            },

            reset: function() {
                this.$v.form.$touch();

                if(!this.$v.form.$invalid) {
                    let args = {
                        numero_dossier: this.form.numero_dossier,
                        date_de_naissance: this.form.date_de_naissance,
                        telephone: this.form.telephone,
                        question_id: this.form.question_id,
                        reponse: this.form.reponse,
                    };

                    this.$store.dispatch('resetSmsPassword', { args });
                }
            }
        },

        mounted() {
            // Retrieve list of question
            this.getQuestionsList();

            new SlimSelect({
                select: '#question',
                placeholder: 'Select secret question'
            }) ;
        },

        validations: {
            model: {
                email: {
                    required,
                    email
                },
            },

            form: {
                numero_dossier: {
                    required,
                    integer,
                    minLength:minLength(8)
                },
                date_de_naissance: {
                    required,
                },
                telephone: {
                    required,
                    integer,
                    minLength:minLength(9)
                },
                question_id: {
                    required,
                    integer

                },
                reponse: {
                    required,
                    minLength:minLength(3)
                },
            }
        },

        watch: {
            $v: {
                handler: function (val) {
                    if(!val.$invalid) {
                        //
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>